import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import type { Tenant } from "../../lib/types";
import { Button } from "../core/Button";
import { UsersTable } from "../../pages/UsersPage";
import { UserFormModal } from "../shared/UserForm";

export function ClientUsersTab({ tenant, autoOpen, onOpened }: { tenant: Tenant; autoOpen: boolean; onOpened: () => void }) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (autoOpen) { setOpen(true); onOpened(); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoOpen]);
  return (
    <div data-testid="client-users-tab">
      <div className="mb-3 flex items-center justify-between gap-2">
        <p className="text-sm text-slate-500">Administrators who can sign in to the {tenant.branding.display_name || tenant.name} console.</p>
        <Button onClick={() => setOpen(true)} data-testid="client-tab-add-user-button"><Plus className="h-4 w-4" />Add user</Button>
      </div>
      <UsersTable tenantId={tenant.id} />
      <UserFormModal open={open} onClose={() => setOpen(false)} lockedTenantId={tenant.id} />
    </div>
  );
}
